let audioContext: AudioContext | null = null;

function getAudioContext(): AudioContext | null {
  if (typeof window === "undefined") return null;
  audioContext ??= new AudioContext();
  return audioContext;
}

export function playInkSound(enabled: boolean, kind: "leaf" | "seal" | "rain" = "leaf"): void {
  if (!enabled) return;
  const context = getAudioContext();
  if (!context) return;
  void context.resume();
  const oscillator = context.createOscillator();
  const gain = context.createGain();
  oscillator.type = kind === "seal" ? "sine" : "triangle";
  oscillator.frequency.setValueAtTime(kind === "rain" ? 260 : kind === "seal" ? 170 : 380, context.currentTime);
  oscillator.frequency.exponentialRampToValueAtTime(110, context.currentTime + 0.24);
  gain.gain.setValueAtTime(0.0001, context.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.045, context.currentTime + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, context.currentTime + 0.26);
  oscillator.connect(gain).connect(context.destination);
  oscillator.start();
  oscillator.stop(context.currentTime + 0.28);
}
